import React from 'react';
import { Menu } from '@headlessui/react';

import { Popup } from 'ui';

import DropdownGroup from './DropdownGroup';
import DropdownItem from './DropdownItem';

type Props = {
  fluid?: boolean;
  trigger: React.ReactNode;
  children: React.ReactNode;
  position?: React.ComponentProps<typeof Popup>['position'];
  onOpen?: () => void;
  closeOnClick?: boolean;
};

function Dropdown({ children, fluid = true, trigger, position = 'bottom right', onOpen, closeOnClick = false }: Props) {
  return (
    <Menu>
      {({ open, close }) => (
        <Popup
          fluid={fluid}
          className=""
          open={open}
          on="click"
          position={position}
          trigger={<Menu.Button as={React.Fragment}>{trigger}</Menu.Button>}
          onOpen={onOpen}
        >
          <Menu.Items
            static
            className="min-w-56 z-10 divide-y rounded-md bg-white shadow-lg outline-none ring-1 ring-black ring-opacity-5"
            onClick={closeOnClick ? close : undefined}
          >
            {children}
          </Menu.Items>
        </Popup>
      )}
    </Menu>
  );
}

export default Object.assign(Dropdown, { Item: DropdownItem, Group: DropdownGroup });
